import { useMemo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ModalActions from 'Redux/ModalRedux'
import { releaseNotesOpenModal, fetchReleaseNotes } from 'Store/release-notes'
import { helpMenuSelector } from './release-notes-modal/release-notes.selector'
import { useFlags } from 'launchdarkly-react-client-sdk'

export function useHelpMenu () {
  const dispatch = useDispatch()
  const flags = useFlags();
  const { hasUnreadeReleaseNotes, accessToken } = useSelector(helpMenuSelector)
  useEffect(() => {
    dispatch(fetchReleaseNotes())
  }, [])

  return useMemo(() => ({
    openOssTerms: () => {
      if(flags.ossAgreementVerification) {
        dispatch(ModalActions.modalOpen('ossTermsV2'));
      } else {
        dispatch(ModalActions.modalOpen('ossTerms'));
      }
    },

    openReleaseModal: () => dispatch(releaseNotesOpenModal()),
    hasUnreadeReleaseNotes
  }), [dispatch, hasUnreadeReleaseNotes])
}
